<template>
  <div>
    <el-dialog
      class="newTopic"
      width="900px"
      :close-on-click-modal="false"
      destroy-on-close
      :visible.sync="dialogFormVisible"
    >
      <el-form
        label-position="left"
        :model="form"
        :rules="rules"
        ref="ruleForm"
        v-if="dialogFormVisible"
      >
        <!-- 上面的v-if="dialogFormVisible"是必须的，为了让没有封面的自动截取封面 -->
        <el-form-item
          style="width: 100%"
          label="题目"
          :label-width="formLabelWidth"
          prop="title"
        >
          <div>
            <div>
              <el-input
                type="textarea"
                id="myTextTextarea"
                maxlength="1000"
                show-word-limit
                style="min-width: 120px"
                :autosize="{ minRows: 5, maxRows: 5 }"
                :placeholder="tipsTitle"
                v-model="form.title"
                resize="none"
              ></el-input>
            </div>
            <div>
              <file
                :fileUrl.sync="form.attachment"
                :fileType.sync="form.attachmentType"
                :cover.sync="form.attachmentCover"
                :buttonName="['上传附件', '更换附件']"
                :getCover="true"
                videoId="qsTitle"
              ></file>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" prop="type">
          <el-select
            @change="updateType"
            v-model="form.type"
            placeholder="请选择题型"
          >
            <el-option label="单选题" value="0"></el-option>
            <el-option label="多选题" value="1"></el-option>
            <el-option label="判断题" value="2"></el-option>
            <el-option label="排序题" value="5"></el-option>
            <el-option label="单项填空" value="3"></el-option>
            <el-option label="多项填空" value="4"></el-option>
          </el-select>
        </el-form-item>
        <!-- 单选题 多选题 判断题 排序题 -->
        <vuedraggable
          v-if="
            form.type == 0 || form.type == 1 || form.type == 2 || form.type == 5
          "
          v-model="form.answers"
          animation="300"
          handle=".mover"
        >
          <el-form-item
            v-for="(item, index) in form.answers"
            :key="index"
            :label-width="formLabelWidth"
            :prop="'answers.' + index + '.content'"
          >
            <div>
              <el-input
                style="width: 300px"
                placeholder="请输入内容"
                v-model="item.content"
                autocomplete="off"
              ></el-input>
              <span>
                <el-button
                  v-if="form.type != '2'"
                  style="margin-left: 20px"
                  @click="addInfo(index)"
                  ><i class="el-icon-plus"></i
                ></el-button>
                <el-button
                  v-if="form.type != '2'"
                  style="margin-left: 20px"
                  @click="removeInfo(index)"
                  ><i class="el-icon-minus"></i
                ></el-button>
                <el-radio
                  @change="
                    (val) => {
                      toRadio(val, item, index);
                    }
                  "
                  style="margin-left: 30px"
                  v-model="item.isCorrect"
                  label="1"
                  v-if="form.type != 5"
                  >正确答案</el-radio
                >
                <el-input
                  style="width: 75px; margin-left: 20px; margin-right: 20px"
                  v-if="form.type == 5"
                  placeholder="排序值"
                  v-model="item.questionSort"
                ></el-input>
                <i
                  v-if="form.type != '2'"
                  style="font-size: 20px"
                  class="bx bx-move mover"
                ></i>
              </span>
            </div>

            <div>
              <file
                v-if="form.type != 2"
                :fileUrl.sync="item.attachment"
                :fileType.sync="item.attachmentType"
                :cover.sync="item.attachmentCover"
                :buttonName="['上传附件', '更换附件']"
                :getCover="true"
                :videoId="`qaAnswer${index}`"
              ></file>
            </div>
          </el-form-item>
        </vuedraggable>
        <!-- 单选填空 -->
        <el-form-item
          v-if="form.type == 3"
          label="设置答案"
          :label-width="formLabelWidth"
          :prop="'answers.' + 0 + '.content'"
          :rules="{
            required: true,
            message: '答案不能为空',
            trigger: 'blur',
          }"
        >
          <div class="flex" style="width: 740px">
            <!-- <span style="marin-right: 10px; min-width: 70px">设置答案 :</span> -->
            <el-input
              style="margin-right: 20px"
              placeholder="请输入内容"
              v-model="form.answers[0].content"
              autocomplete="off"
            ></el-input>
            <el-checkbox v-model="form.answers[0].scoreRule"
              >包含答案即可得分</el-checkbox
            >
            <el-checkbox v-model="form.caseSensitive">区分大小写</el-checkbox>
            <el-checkbox v-model="form.casePunctuation"
              >区分标点符号</el-checkbox
            >
          </div>
          <button
            type="button"
            class="btn-sm btn btn-primary m-r-10"
            @click="addBlank()"
          >
            插入填空符
          </button>
        </el-form-item>
        <!-- 多选填空 -->
        <el-form-item v-if="form.type == 4" :label-width="formLabelWidth">
          <button
            type="button"
            class="btn-sm btn btn-primary m-r-10"
            @click="addBlank()"
          >
            插入填空符
          </button>
          <button
            type="button"
            class="btn-sm btn btn-primary m-r-20"
            @click="answerSetting()"
          >
            答案设置
          </button>
          <el-checkbox v-model="form.caseSensitive">区分大小写</el-checkbox>
          <el-checkbox v-model="form.casePunctuation">区分标点符号</el-checkbox>
        </el-form-item>
        <!-- 答题提示 -->
        <el-form-item label="答题提示" :label-width="formLabelWidth">
          <Editor
            style="width: 100%"
            :height="250"
            v-if="dialogFormVisible"
            v-model="form.tipContent"
          />
        </el-form-item>
        <!-- 错题解析 -->
        <el-form-item label="错题解析" :label-width="formLabelWidth">
          <Editor
            style="width: 100%"
            :height="250"
            v-if="dialogFormVisible"
            v-model="form.analysisContent"
          />
        </el-form-item>
        <!-- 分值设置 -->
        <el-form-item
          label="分值设置"
          :label-width="formLabelWidth"
          prop="score"
        >
          <el-input
            v-model="form.score"
            style="width: 300px"
            placeholder="请输入分值"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <!-- 状态 -->
        <el-form-item :label-width="formLabelWidth">
          <div>
            <span style="margin-right: 20px"> 状态 </span>
            <span>
              <el-radio v-model="form.state" :label="1">启用</el-radio>
              <el-radio v-model="form.state" :label="0">禁用</el-radio>
            </span>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="submitTopic('ruleForm')">
          <span v-if="!index_id"> 创 建 </span>
          <span v-else> 保 存 </span>
        </el-button>
      </div>
      <!-- 答案设置 -->
      <el-dialog
        width="50%"
        title="填空属性"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div style="margin-bottom: 20px">当前题目：{{ answerTitle }}</div>
        <div class="table-responsive-main-list">
          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th style="text-align: center" scope="col">填空</th>
                  <th style="text-align: center; width: 300px" scope="col">
                    答案
                  </th>
                  <th style="text-align: center; width: 320px" scope="col">
                    得分规则
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in answerList" :key="index">
                  <td style="text-align: center">{{ item.title }}</td>
                  <td style="text-align: center">
                    <el-popover
                      v-if="!item.content"
                      placement="bottom"
                      width="200"
                      trigger="click"
                    >
                      <el-input
                        style="margin-bottom: 10px"
                        placeholder="输入内容"
                        v-model="contentValue"
                        autocomplete="off"
                        clearable
                      ></el-input>
                      <div class="flex" style="margin: 0">
                        <el-button
                          style="width: 50%"
                          size="mini"
                          type="text"
                          @click="visible = false"
                          >取消</el-button
                        >
                        <el-button
                          style="width: 50%"
                          type="primary"
                          size="mini"
                          @click="checkAnswer(item, index)"
                          >确定</el-button
                        >
                      </div>
                      <el-button size="mini" slot="reference"
                        >新增答案</el-button
                      >
                    </el-popover>

                    <el-tag
                      disable-transitions
                      @close="handleTagClose(item)"
                      v-else
                      closable
                    >
                      {{ item.content }}
                    </el-tag>
                  </td>
                  <td style="text-align: center">
                    <b-form-select
                      v-model="item.scoreRule"
                      class="form-select"
                      :options="answersOption"
                      type="text"
                    ></b-form-select>
                  </td>
                </tr>
                <tr v-if="!answerList[0]">
                  <td colspan="8" style="text-align: center">暂无数据</td>
                </tr>
              </tbody>

              <!-- <tfoot class="table-light">
                        <tr>
                          <td colspan="8">
                            <span
                              style="cursor: pointer"
                              @click="openTopicDialog()"
                            >
                              <i class="el-icon-circle-plus-outline"></i
                              >&ensp;添加题目
                            </span>
                          </td>
                        </tr>
                      </tfoot> -->
            </table>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="innerVisible = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="submitAnswer()"
            >保 存</el-button
          >
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Editor from "@/components/newEditor/Editor.vue";
import question from "@/server/api/question";
import vuedraggable from "vuedraggable";
import File from "@/components/file/File.vue";

export default {
  components: {
    Editor,
    vuedraggable,
    File,
  },
  data() {
    return {
      // show: "",
      dialogFormVisible: false,

      form: {
        title: "",
        state: 1,
        answers: [{ content: "", isCorrect: "" }],
        type: "0",
        caseSensitive: "", //0-忽略大小写,1-大小写敏感
        casePunctuation: "", //0-忽略标点符号,1-标点符号敏感
        analysisContent: "", //解析
        tipContent: "", //提示
        score: "", //分数
      },
      formLabelWidth: "80px",

      rules: {
        // title: [{ required: true, message: "请输入题目", trigger: "blur" }],
        type: [{ required: true, message: "请选择题型", trigger: "change" }],
        score: [{ required: true, message: "请输入分数", trigger: "blur" }],
      },
      tipsTitle: "请输入内容",
      innerVisible: false,
      currentTopic: [],
      answersOption: [
        { text: "完全匹配得分", value: 0 },
        { text: "包含答案即可得分", value: 1 },
      ],
      answerList: [],
      answerTitle: "",
      visible: false,
      contentValue: "",
      index_id: null,
    };
  },
  methods: {
    showModel(item) {
      let that = this;
      if (item) {
        that.index_id = item.id;
        that.$nextTick(() => {
          that.toDetail(item);
        });
      } else {
        that.index_id = null;
        // console.log(this.answerList);
        this.answerList = [];
        this.tipsTitle = "请输入内容";
        that.resetForm();
        this.dialogFormVisible = true;
      }
      // that.show = true;
    },
    //选择题型时
    updateType() {
      this.tipsTitle = "请输入内容";
      if (this.form.type == "0") {
        this.form.answers = [{ content: "", isCorrect: "" }];
      }
      if (this.form.type == "1") {
        this.form.answers = [
          { content: "", isCorrect: "" },
          { content: "", isCorrect: "" },
        ];
      }
      if (this.form.type == "2") {
        this.form.answers = [
          { content: "", isCorrect: "" },
          { content: "", isCorrect: "" },
        ];
      }
      if (this.form.type == "3") {
        this.form.answers = [{ content: "", isCorrect: "" }];
      }
      if (this.form.type == "4") {
        this.form.title = "";
        this.tipsTitle = "题1__________题2__________题3__________";
      }
      if (this.form.type == 5) {
        this.form.answers = [
          { content: "", questionSort: "" },
          { content: "", questionSort: "" },
        ];
      }
    },
    //新增问题
    addQuestion(item) {
      let params = JSON.parse(JSON.stringify(item));
      params.score = Number(params.score);
      console.log(params);
      question.questionAdd(item).then((res) => {
        if (res.code == 0) {
          this.$emit("change", ""); //让父组件刷新列表
          this.success("题目创建成功");
          this.dialogFormVisible = false;
          console.log(res.data);
          if (res.data) {
            let current = {
              code: "questionTopic",
              item: res.data,
            };
            this.$emit("pageCallback", current);
          }
        } else {
          this.warning(res.msg);
        }
      });
    },

    //修改问题
    saveQuestion(_item) {
      let item = _item;
      if (item.updatedAt) {
        delete item.updatedAt;
      }
      question.questionModify(item).then((res) => {
        if (res.code == 0) {
          this.$emit("change", item.id); //让父组件刷新列表
          this.dialogFormVisible = false;
          this.success("题目修改成功");
          this.$emit("pageCallback", "");
          // this.getList();
        } else {
          this.warning(res.msg);
        }
      });
    },
    //提交问题
    submitTopic(formName) {
      //有附件时只需要上传附件，选择题和排序题的选项才有附件
      if (!this.checkForm()) {
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.form));
          params.type = Number(params.type);
          /* 单选 */
          if (this.form.type == "0") {
            let num = 0;
            params.answers.forEach((v, i) => {
              v.sort = i;
              v.scoreRule = 0;
              if (v.isCorrect == 1) {
                v.isCorrect = 1;
                num++;
              } else {
                v.isCorrect = 0;
              }
            });
            if (num > 1) {
              Vue.swal("单选只能选择一个答案");
              this.form.answers.forEach((v) => {
                v.isCorrect = 0;
              });
              return;
            }
            if (num == 0) {
              Vue.swal("必须选择一个答案");
              return;
            }
            if (params.answers.length < 2) {
              Vue.swal("至少需要两种选项");
              return;
            }
            params.caseSensitive = 0;
            params.casePunctuation = 0;
          }
          /* 多选 */
          if (this.form.type == "1") {
            let num = 0;
            params.answers.forEach((v, i) => {
              v.sort = i;
              v.scoreRule = 0;

              if (v.isCorrect == 1) {
                v.isCorrect = 1;
                num++;
              } else {
                v.isCorrect = 0;
              }
            });
            if (num < 2) {
              Vue.swal("必须选择两种答案");
              this.form.answers.forEach((v) => {
                v.isCorrect = 0;
              });
              return;
            }
            if (params.answers.length < 2) {
              Vue.swal("多选至少需要两种选项");
              return;
            }

            params.caseSensitive = 0;
            params.casePunctuation = 0;
          }
          /* 判断 */
          if (this.form.type == "2") {
            let num = 0;
            params.answers.forEach((v, i) => {
              v.sort = i;
              v.scoreRule = 0;
              if (v.isCorrect == 1) {
                v.isCorrect = 1;
                num++;
              } else {
                v.isCorrect = 0;
              }
            });
            if (num == 0) {
              Vue.swal("必须选择一个答案");
              return;
            }
            if (num > 1) {
              Vue.swal("判断只能选择一个答案");
              this.form.answers.forEach((v) => {
                v.isCorrect = 0;
              });
              return;
            }

            params.caseSensitive = 0;
            params.casePunctuation = 0;
          }
          /* 单选填空 */
          if (this.form.type == "3") {
            params.caseSensitive = params.caseSensitive ? 1 : 0;
            params.casePunctuation = params.casePunctuation ? 1 : 0;
            params.answers[0].scoreRule = params.answers[0].scoreRule ? 1 : 0;
            params.answers[0].sort = 0;
            params.answers[0].isCorrect = 1;
          }
          /* 多选填空 */
          if (this.form.type == "4") {
            params.caseSensitive = params.caseSensitive ? 1 : 0;
            params.casePunctuation = params.casePunctuation ? 1 : 0;
            let userList = JSON.parse(JSON.stringify(this.answerList));
            userList.forEach((v) => {
              delete v.title;
            });
            params.answers = userList;
            if (params.answers.length == 0) {
              Vue.swal("请设置多项填空答案");
              return;
            }

            // params.answers[0].scoreRule = params.answers[0].scoreRule ? 1 : 0;
            // params.answers[0].sort = 0;
            // params.answers[0].isCorrect = 1;
            // console.log(params);
            // this.addQuestion(params);
          }
          console.log("保存参数", params);
          if (!this.index_id) {
            this.addQuestion(params);
          } else {
            this.saveQuestion(params);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //重置问题
    resetForm() {
      // this.form = this.$options.data().form;
      this.form = this.$options.data.call(this).form;
      // this.form.title = "";
      // this.form.state = 1;
      // this.form.caseSensitive = "";
      // this.form.casePunctuation = "";
      // this.form.analysisContent = "";

      // this.form.answers = [{ content: "", isCorrect: "" }];
      // this.form.type = "0";
      // this.tipsTitle = "请输入内容";
      // this.answerList = [];
    },
    //增加选项
    addInfo() {
      if (this.form.type != "judge") {
        let item = { content: "", isCorrect: "" };
        this.form.answers.push(item);
      }
    },
    //删除选项
    removeInfo(i) {
      // if (this.form.type == "judge") {
      // } else {
      //   if (this.form.answers.length != 1) {
      //     this.form.answers.splice(i, 1);
      //   }
      // }
      if (this.form.type == "") {
        if (this.form.answers.length > 1) {
          this.form.answers.splice(i, 1);
        }
      }
      if (this.form.type == "0" && this.form.answers.length > 1) {
        this.form.answers.splice(i, 1);
      }
      if (this.form.type == "2" && this.form.answers.length > 2) {
        this.form.answers.splice(i, 1);
      }
      if (this.form.type == "1" && this.form.answers.length > 2) {
        this.form.answers.splice(i, 1);
      }
    },
    //插入填空符
    addBlank() {
      // this.form.title = this.form.title + "____";
      // 获取对应input的DOM
      var inputDOM = document.getElementById("myTextTextarea");
      var startCursor = inputDOM.selectionStart; // 开始光标位置
      var endCursor = inputDOM.selectionEnd; // 结束光标位置
      if (startCursor === undefined || endCursor === undefined) {
        this.form.title = this.form.title + "____";
        return;
      }
      // 最终的处理结果
      this.form.title =
        this.form.title.substring(0, startCursor) +
        "____" +
        this.form.title.substring(endCursor);
      inputDOM.focus();
    },
    //答案设置
    answerSetting() {
      if (!this.form.title) {
        Vue.swal("请先填写标题");
      } else {
        this.answerTitle = this.form.title;
        let reg = /_{2,1000}/g;
        let usStr = JSON.parse(JSON.stringify(this.answerTitle));
        usStr = usStr.replace(reg, "____");
        let numArr = usStr.match(/____/g);
        if (!numArr) {
          Vue.swal("请填写正确的题目");
          return;
        }
        if (this.index_id) {
          this.answerList = numArr.map((v, i) => {
            return {
              title: "填空" + this.utils.toChinesNum(i + 1),
              isCorrect: this.answerList[i] ? this.answerList[i].isCorrect : 1,
              scoreRule: this.answerList[i] ? this.answerList[i].scoreRule : 1,
              sort: i,
              content: this.answerList[i] ? this.answerList[i].content : "",
            };
          });
        } else {
          if (this.answerList.length == 0) {
            this.answerList = numArr.map((v, i) => {
              return {
                title: "填空" + this.utils.toChinesNum(i + 1),
                isCorrect: 1,
                scoreRule: 1,
                sort: i,
                content: "",
              };
            });
          } else {
            let usArr = JSON.parse(JSON.stringify(this.answerList));
            this.answerList = usArr.map((v, i) => {
              return {
                title: "填空" + this.utils.toChinesNum(i + 1),
                isCorrect: 1,
                scoreRule: v.scoreRule,
                sort: i,
                content: v.content,
              };
            });
          }
        }
        this.innerVisible = true;
      }
    },
    //设置答案内容
    checkAnswer(item, index) {
      item.content = this.contentValue;
      this.contentValue = "";
      this.visible = false;
    },
    //标签关闭
    handleTagClose(item) {
      item.content = "";
    },
    //提交答案
    submitAnswer() {
      for (let i = 0; i < this.answerList.length; i++) {
        const element = this.answerList[i];
        if (element.content == "") {
          Vue.swal("请填写新增答案");
          return;
        }
      }
      this.innerVisible = false;
    },
    toDetail(item) {
      question.questionDetail({ id: item.id }).then((res) => {
        console.log("题目详情", res);
        if (res.code == 0) {
          this.dialogFormVisible = true;
          this.form = res.data;
          this.dialogFormVisible = true;

          this.form.type = this.form.type + "";
          this.form.answers.forEach((v) => {
            v.isCorrect = v.isCorrect + "";
          });

          if (this.form.type == "3") {
            this.form.answers[0].scoreRule =
              this.form.answers[0].scoreRule == 1 ? true : false;
          }
          this.form.caseSensitive = this.form.caseSensitive == 1 ? true : false;
          this.form.casePunctuation =
            this.form.casePunctuation == 1 ? true : false;
          if (this.form.type == "4") {
            this.answerList = this.form.answers;
          }
        }
      });
    },
    toRadio(val, item, index) {
      if (this.form.type == 0 || this.form.type == 2) {
        this.form.answers.forEach((v) => {
          v.isCorrect = "";
        });
        this.form.answers[index].isCorrect = "1";
      }
    },
    //有附件时可以只有附件不要文字题目和文字答案
    checkForm() {
      let data = this.form;
      if (!data.title && !data.attachment) {
        this.warning("请填写题目或上传附件");
        return;
      }
      let arr = this.form.answers;
      let len = arr.length;
      let sort = [];

      if ([0, 1, 2, 5].indexOf(Number(this.form.type)) != -1) {
        for (let i = 0; i < len; i++) {
          if (!arr[i].content && !arr[i].attachment) {
            this.warning(`选项${i + 1}请填写文字答案或上传附件`);
            return;
          }
          if (this.form.type == 5) {
            //排序题需要验证排序值
            if (
              arr[i].questionSort === "" ||
              arr[i].questionSort === undefined
            ) {
              this.warning(`选项${i + 1}请填写排序值`);
              return;
            }
            let temp = Number(arr[i].questionSort);
            if (temp <= 0 || isNaN(temp) || temp != parseInt(temp)) {
              this.warning(`选项${i + 1}的排序值请填写大于0的整数`);
              return;
            }
            let index = sort.indexOf(temp);
            if (index != -1) {
              this.warning(
                `选项${i + 1}的排序值与选项${index + 1}的排序值重复`
              );
              return;
            }
            if (temp > len) {
              this.warning(`选项${i + 1}的排序值请填写不大于选项总数的整数`);
              return;
            }
            arr[i].sort = i;
            arr[i].scoreRule = 0;
            arr[i].questionSort = temp;
            arr[i].isCorrect = 1;
            sort.push(temp);
          }
        }
      }

      if (this.form.type == 5) {
        this.form.caseSensitive = 0;
        this.form.casePunctuation = 0;
        if (len < 2) {
          this.warning(`排序题至少有两个选项`);
          return;
        }
      }
      return true;
    },
  },
};
</script>
<style lang="scss">
.newTopic {
  .el-dialog__body {
    max-height: calc(100vh - 200px);
    overflow: auto;
  }
}
</style>
<style scoped lang="scss"></style>
